// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module_container_3eRb_","animation-container":"index-module_animation-container_Ukk6Q"};